import isEmpty from 'lodash/isEmpty'
import { take, select } from 'redux-saga/effects'
import { COOKIE_KEYS, LOCALSTORAGE_KEYS } from '@features/General'
import { history } from '@components/App'
import request from '@utils/request'
import store from '@store/store'
import { rootActions } from '@store/slices'
import { RootState } from '@app-store/store'
import routes from '@utils/constants/routes'

export const setUserAuthCookie = (token: string, role = '') => {
    const isRemember = `max-age=${1 * 365 * 24 * 60 * 60};`
    document.cookie = `${COOKIE_KEYS.ALA_TOKEN}=${encodeURI(token)};${isRemember};path=/;secure;`
}

export const setRefreshTokenCookie = (token: string, role = '') => {
    const isRemember = `max-age=${1 * 365 * 24 * 60 * 60};`
    document.cookie = `${COOKIE_KEYS.ALA_REFRESH}=${encodeURI(token)};${isRemember};path=/secure;`
}

export const setUserRoleCookie = (role, type) => {
    const isRemember = `max-age=${1 * 365 * 24 * 60 * 60};`
    document.cookie = `${COOKIE_KEYS.ALA_USER_ROLE}=${encodeURI(role)};${isRemember};path=/`
    document.cookie = `${COOKIE_KEYS.ALA_USER_TYPE}=${encodeURI(type)};${isRemember};path=/`
}

export const setEventCookie = event => {
    request.defaults.headers.common = {
        ...request.defaults.headers.common,
        'event-id': event
    }
    const isRemember = `max-age=${1 * 365 * 24 * 60 * 60};`
    document.cookie = `${COOKIE_KEYS.ALA_EVENT}=${encodeURI(event)};${isRemember};path=/`
}

export const removeUserAuthCookie = () => {
    delete request.defaults.headers?.common?.['event-id']
    document.cookie = `${COOKIE_KEYS.ALA_TOKEN}=;max-age=0;path=/`
    document.cookie = `${COOKIE_KEYS.ALA_REFRESH}=;max-age=0;path=/`
    document.cookie = `${COOKIE_KEYS.ALA_USER_ROLE}=;max-age=0;path=/`
    document.cookie = `${COOKIE_KEYS.ALA_USER_TYPE}=;max-age=0;path=/`
    document.cookie = `${COOKIE_KEYS.ALA_EVENT}=;max-age=0;path=/`
    history.replace('/login')
    localStorage.removeItem(LOCALSTORAGE_KEYS.USERINFO)
    localStorage.removeItem(LOCALSTORAGE_KEYS.CONTACT_INFO)
    store.dispatch(
        rootActions.ui.authSlider.setLoggedInInfo({
            redirectUrl: ''
        })
    )
}

export const getSubDomain = () => {
    // 'https://monshaat.aladdinb2b.com' - This is for testing purpose.
    // window.location.href                 - Put it in when live.

    const url = window.location.href
    // const url = 'https://monshaatt.aladdinb2b.com/'
    const [, topLevel_domain] = url.split('//', 5)
    const [subdomain] = topLevel_domain.split('.')
    return subdomain.includes('localhost:7080') ? 'localhost' : subdomain
}

export function* successLogin(response, sagaCB) {
    const { jwtToken } = response?.idToken
    const { token } = response?.refreshToken
    if (!isEmpty(token)) yield setRefreshTokenCookie(token)
    if (!isEmpty(jwtToken)) {
        yield setUserAuthCookie(jwtToken)
        store.dispatch(
            rootActions.users.profile.onRequest({
                sagaCB: {
                    onSuccess: result => {
                        if (sagaCB) {
                            sagaCB?.onSuccess(result)
                        }
                    }
                }
            })
        )
        yield take('hub/user/profile/onSuccess')
        store.dispatch(rootActions.auth.login.onSuccess({ token: jwtToken }))
        const data = yield select((store: RootState) => store.ui.authDynamic.data)
        if (data?.sub_domain) {
            store.dispatch(
                rootActions.companies.checkStatusEvent.onRequest({
                    event: data,
                    sagaCB: {
                        onSuccess: response => {
                            if (!response.result.itpOnboarded) {
                                const user: any = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEYS.USERINFO))
                                const eventUserInfo = user.eventInfos.find(x => x.eventId === data._id || data)
                                store.dispatch(
                                    rootActions.companies.onboardingExhibitor.set({
                                        type: 'isAdmin',
                                        value: true
                                    })
                                )
                                if (eventUserInfo?.role.type === 'User') {
                                    history.push(routes.exhibitor.onboarding.itp._.replace(':state', 'location'))
                                }
                            }
                        }
                    }
                })
            )
        }
    }
}
